<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (onSelectAll)="onSelectAll($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div class="card-toolbar" before-btns>
    <!-- updateGroup btn -->
    <div [matTooltip]="'common.updateGroup' | translate">
      <button
        (click)="onUpdateGroup()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-pencil mdi-20px tw-p-0 text-primary"></i>
      </button>
    </div>

    <!-- groupDeletion btn -->
    <div [matTooltip]="'common.groupDeletion' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
    </div>
  </div>

  <!---------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- checkbox -->
        <td>
          <div class="form-check text-center">
            <input
              type="checkbox"
              class="form-check-input tw-mr-0"
              (click)="onAddSelectedId($event, item?.id, row)"
              [attr.data-checkbox-id]="item.id"
            />
          </div>
        </td>

        <!-- id -->
        <td class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center">
          {{ item?.id }}
        </td>

        <!-- name -->
        <td>
          <td-value copyToClipboard [value]="item?.name"></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- status -->
        <td>
          <span
            *ngIf="item?.status == VoiceStatus.AwaitingConfirmation"
            [matTooltip]="item?.status | enumToText : VoiceStatusEnumValues"
          >
            <i class="mdi mdi-circle-slice-4 mdi-20px text-info mdi-spin"></i>
          </span>

          <span
            *ngIf="item?.status == VoiceStatus.AwaitingPhoneConfirmation"
            [matTooltip]="item?.status | enumToText : VoiceStatusEnumValues"
          >
            <i class="mdi mdi-cellphone mdi-20px text-navyBlue"></i>
          </span>

          <span
            *ngIf="item?.status == VoiceStatus.Accepted"
            class="text-success tw-font-medium"
            [matTooltip]="item?.status | enumToText : VoiceStatusEnumValues"
          >
            <i class="mdi mdi-check-bold mdi-18px text-success"></i>
          </span>
          <span
            *ngIf="item?.status == VoiceStatus.Failed"
            class="text-danger tw-font-medium"
            [matTooltip]="item?.status | enumToText : VoiceStatusEnumValues"
          >
            <i class="mdi mdi mdi-close-thick mdi-18px text-danger"></i>
          </span>
        </td>

        <!-- CreationLocation -->
        <td>
          <span class="tw-text-sm">
            {{
              item?.creationLocation | enumToText : CreationLocationEnumValues
            }}</span
          >
        </td>

        <!-- path -->
        <td [style.width.px]="'400'">
          <app-audio-controller
            class="tw-block tw-w-[300px]"
            [smallSize]="true"
            [audioSrc]="item?.path | addApiUrlBeforePath"
          ></app-audio-controller>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!-- <app-table-operations [model]="item" (onDelete)="onDelete($event.id,$event.name)"
            (onUpdate)="onUpdate(item?.id)">
          </app-table-operations> -->

          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit Status button -->
            <div app-menu-btn *ngIf="permissionService.userState()?.organizationId == 1" icon="edit" [title]="'common.editStatus'"
              (click)="onEditStatus(item)">
            </div>
          

            <!-- get new status button -->
            <div app-menu-btn *ngIf="permissionService.userState()?.organizationId == 1" icon="mdi mdi-autorenew mdi-20px"
              color="indigo" [title]="'common.getNewStatus'" (click)="onGetNewStatus(item.id, item.name)"></div>
          

            <!-- delete button -->
            <div app-menu-btn icon="delete" (click)="onDelete(item.id, item?.name)">
            </div>
          
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-voice-messages-form
    page-form
    [formPageConfig]="formPageConfig"
    [voiceGroup]="input_group"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-voice-messages-form>
</ng-container>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>
